var map = {
	"./about.ts": "188b",
	"./course.ts": "c975",
	"./home.ts": "6b72",
	"./project.ts": "485f",
	"./question.ts": "a5c6",
	"./student.ts": "7a2b",
	"./teacher.ts": "99b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "795e";